import { render, staticRenderFns } from "./Archive2024Component.vue?vue&type=template&id=bc42356e&scoped=true"
import script from "./Archive2024Component.vue?vue&type=script&lang=js"
export * from "./Archive2024Component.vue?vue&type=script&lang=js"
import style0 from "./Archive2024Component.vue?vue&type=style&index=0&id=bc42356e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc42356e",
  null
  
)

export default component.exports